
const cssVar = value => {
  const match = /var\((--[^)]+)\)/.exec(value);
  const name = match ? match[1] : value;
  return typeof window !== 'undefined'
    ? getComputedStyle(document.documentElement).getPropertyValue(name).trim() || name
    : name;
};

export const EMPLOYEE_COLORS_ARRAY =
  Array.from({ length: 35 }, (_, i) => cssVar(`var(--employee-${i})`));

const STORAGE_KEY = 'employee-colors';

const loadMap = () => {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

const saveMap = map => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  }
};

export const resetEmployeeColors = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(STORAGE_KEY);
  }
};

const colorMap = { ...loadMap() };

export const getEmployeeColor = id => {
  if (!id) return EMPLOYEE_COLORS_ARRAY[0];
  if (!colorMap[id]) {
    const used = new Set(Object.values(colorMap));
    const available = EMPLOYEE_COLORS_ARRAY.filter(c => !used.has(c));
    const random = available[Math.floor(Math.random() * available.length)] || EMPLOYEE_COLORS_ARRAY[Math.floor(Math.random() * EMPLOYEE_COLORS_ARRAY.length)];
    colorMap[id] = random;
    saveMap(colorMap);
  }
  return colorMap[id];
};

export const EMPLOYEE_COLORS_MAP = colorMap;
export const EMPLOYEE_COLORS_KEYS = Object.keys(colorMap).map(Number);
